<template>
    <div class="pc-root-container">
        <div style="width: 1366px; margin: auto;">
            <div class="header">
                <img src="@/assets/pc/img_main_banner.jpg" width="100%"/>

                <div class="logo-container">
                    <img src="@/assets/pc/ic_dorbomplus_logo.png"/>
                    <div>
                        <span class="header-title">워킹맘, 워킹대디가<br>안심하고 일 할 수 있도록</span>
                    </div>
                    <div style="text-align: left; margin-top: 16px; font-size: 20px; font-weight: 500; color: black; line-height: 1.7">
                        <span>영유아 전문 돌봄 서비스,<br>돌봄플러스가 도와드리겠습니다.</span>
                    </div>
                </div>

                <div class="header_character-container">
                    <div>
                        <img src="@/assets/pc/img_header_logo1.png"/>
                        <img src="@/assets/pc/img_header_logo2.png" style="margin-left: 18px; margin-bottom: 7px"/>
                    </div>
                </div>
            </div>

            <div>
                <div class="introduce_container">
                    <img src="@/assets/pc/ic_dorbom_app_logo.png">
                    <span>돌봄플러스는 0~5세 아이를 키우는 부모 임직원의 일과 가정이<br>양립할 수 있도록 믿을 수 있는 돌봄 선생님을 제공합니다.</span>
                </div>
            </div>
        </div>

        <img src="@/assets/pc/img-part-2-mainimg.png" style="margin-top: 23px"/>

        <div class="score-container">
            <div class="score-title">
                <span>부모님 만족도</span>
                <span class="poppins" style="font-weight: 400; font-size: 24px;"> 5</span>
                <span>점 만점에</span>
                <span class="poppins" style="font-weight: 700"> 4.7</span>
                <span>점!</span>
            </div>
            <img src="@/assets/pc/icon-part-3-stars-all.png" style="margin-top: 18px"/>
        </div>

        <div style="background-color: #f4f4f4; padding-top: 60px; padding-bottom: 110px;">
            <div style="display: flex; flex-direction: row; justify-content: center;">
                <img src="@/assets/pc/grp-part-3-review-1.png">
                <img src="@/assets/pc/grp-part-3-review-2.png">
            </div>
            <div style="display: flex; flex-direction: row; justify-content: center; margin-top: 10px;">
                <img src="@/assets/pc/grp-part-3-review-3.png">
                <img src="@/assets/pc/grp-part-3-review-4.png">
            </div>
        </div>

        <div style="display: flex; flex-direction: row; justify-content: center; padding-top: 171px; padding-bottom: 120px">
            <div>
                <img src="@/assets/pc/img-part-3-chick-1.png"/>
                <span class="chick-title"
                      style="display: block; margin-top: 24px;">부모님이 신청서를<br>작성하면 돌봄 선생님과<br>만납니다!</span>
            </div>
            <div style="margin-left: 169px;">
                <img src="@/assets/pc/img-part-3-chick-2.png"/>
                <span class="chick-title" style="display: block; margin-top: 24px;">부모님이 돌봄플러스와<br>1년 이상 함께<br>하고 계십니다!</span>
            </div>
        </div>

        <div class="dorbom-score-container">
            <span>돌봄플러스가 아이와 함께 한 시간은?</span>
            <div>
                <span>167,019</span>
                <span>시간</span>
            </div>
            <span>* 2021년 10월 18일 오후 12시 기준</span>
        </div>

        <div class="why-special">
            <div class="special">
                <span class="emphasized">“</span>
                <span>돌봄플러스와 바뀌는 기업 문화</span>
                <span class="emphasized">”</span>
            </div>

            <img style="margin-top: 120px" src="@/assets/pc/grp-part-4-corporateculture.png"/>
        </div>

        <div class="allhappy-container">
            <div>
                <span class="emphasized">“</span>
                <span>모두가 편한 복지</span>
                <span class="emphasized">”</span>
            </div>
            <div style="color: #454545">
                기업은 업무 효율성과 낮은 이직률,<br>자녀를 둔 부모 임직원은 일과 가정의 균형,<br>아이는 편안하고 안전한 시간.
            </div>
            <div>
                이 모든 것이 돌봄플러스로부터.
            </div>
            <img style="margin-top: 84px;" src="@/assets/pc/grp-part-7-map.png"/>
        </div>

        <div class="service-container">
            <div style="position: relative; height: 112px; width: 604px; margin: auto">
                <span class="emphasized">“</span>
                <span>돌봄 서비스 안내</span>
                <span class="emphasized">”</span>
                <img src="@/assets/pc/pc.png" style="position: absolute; bottom: 0;">
            </div>
            <div>
                <div>
                    <img width="1100px" src="@/assets/pc/chart-part-6-servicekind.png"/>
                </div>
                <span style="font-size: 14px; color: rgba(0, 0, 0, 0.25); margin-left: -760px;">
                    * 서비스 이용 가능 지역: 서울특별시, 경기도 및 인천 일부 지역
                </span>
            </div>
        </div>

        <div class="allhappy1-container">
            <div>
                <span class="emphasized">[</span>
                <span> 절로 웃음이 나는 가격 </span>
                <span class="emphasized">]</span>
            </div>
            <div>
                <div style="display: flex; flex-direction: row; margin-top: 80px; justify-content: center">
                    <div style="margin-right: 40px;">
                        <img src="@/assets/pc/img-part-8-basiccoupon.png"/>
                        <div style="text-align: center; color: #454545; font-size: 14px; margin-top: 6px;">
                            <span>[베이직 쿠폰: 기본 돌봄 4시간]</span>
                        </div>
                    </div>
                    <div style="margin-left: 40px;">
                        <img src="@/assets/pc/img-part-8-premiumcoupon.png"/>
                        <div style="text-align: center; color: #454545; font-size: 14px; margin-top: 6px;">
                            <span>[프리미엄 쿠폰: 가사 돌봄 5시간]</span>
                        </div>
                    </div>
                </div>
            </div>
            <div class="allhappy-caution" style="margin: 50px auto; text-align: center;">
                <img src="@/assets/pc/chart.png" width="700px" height="669px">

                <div style="text-align: center; margin: 30px auto; width: 700px;">
                    <div style="text-align: left; margin-top: 30px;">
                        <span>* 위 가격은 패키지 옵션에 따른 가격이며, 아이 추가나 시간 초과시 별도의 요금이 청구될 수 있습니다.</span>
                    </div>
                    <div style="text-align: left; margin-top: 8px; line-height: 22px;">
                        <span>* 베이직 쿠폰(기본 돌봄 4시간)은 4,400원(원금 44,000원, 정부지원 90%),<br>프리미엄 쿠폰(가사 돌봄 5시간)은 6,000원(원금 60,000원, 정부지원 90%)에 개별 구매가 가능합니다.</span>
                    </div>
                </div>
            </div>
        </div>

        <div class="allhappy2-container">
            <div>
                <span class="emphasized">[</span>
                <span> 비대면 바우처로 돌봄플러스 신청하기 </span>
                <span class="emphasized">]</span>
            </div>

            <img style="margin-top: 63px;" src="@/assets/pc/grp-part-9-map.png"/>
        </div>

        <div style="width: 1366px; margin: auto;" class="contact-container">

          <div>
            <span class="emphasized">[</span>
            <span> 비대면 바우처 자주 묻는 질문 </span>
            <span class="emphasized">]</span>
          </div>

          <div>

            <div style="margin-top: 80px;">
              <ArcordianView number="1" title="서비스 이용 가능한 지역이 어디인가요?" text="서울 모든 지역과 경기 고양시, 구리시, 김포시, 남양주시, 부천시, 수원시, 성남시, 용인시, 하남시입니다.<br>이 외의 지역도 원활한 매칭이 될 수 있게 지속적으로 돌봄 선생님을 모집하고 교육하고 있으나, 환불이 불가한 비대면 바우처 특성상 서비스 불가능한 점 양해 부탁드립니다."/>
              <ArcordianView number="2" title="유효기간은 언제까지인가요?" text="구입 후 2년까지 사용 가능합니다." style="margin-top: 32px"/>
              <ArcordianView number="3" title="1,900,000원을 구매하고 싶은데 어떻게 해야하나요?" text="300,000원, 600,000원, 1,000,000원 비대면 바우처를 각각 1개씩 구매하시면 됩니다." style="margin-top: 32px"/>
              <ArcordianView number="4" title="두 달 패키지를 구매하면 꼭 두 달 안에 다 써야하나요?" text="예를 들어 두 달 패키지, 즉 2,000,000원 비대면 바우처를 구매하시면 2,184,000원에 대한 쿠폰이 지급됩니다. 금액권으로 생각하시고, 2년 이내에는 자유롭게 사용 가능합니다." style="margin-top: 32px"/>
              <ArcordianView number="5" title="통합발급과 개별발급의 차이점은 뭔가요?" text="예를 들어 1,000,000원을 구매하시면 통합발급은 1,092,000원 쿠폰 1장이 발급되고, 발급 후 300,000원만 먼저 사용을 하신다면 나머지 금액은 크레딧으로 전환되어 현금처럼 사용 가능합니다. 그리고 1,000,000원을 개별발급 받으신다면 베이직쿠폰 18장과 프리미엄 쿠폰 5장이 발급됩니다. 한 돌봄신청서당 1개의 쿠폰만 사용 가능하므로 하루 돌봄으로만 이용을 원하신다면 개별발급을, 이틀 이상의 돌봄 이용을 원하신다면 통합발급을 추천해 드립니다." style="margin-top: 32px"/>
              <ArcordianView number="6" title="통합발급은 어떻게 받나요?" text="메일로 쿠폰과 같이 발송된 매뉴얼 참고 부탁드리며, 쿠폰 리스트에서 등록할 쿠폰을 모두 복수 선택한 후에 쿠폰 통합발급에 체크하고 [쿠폰 발급하기] 버튼을 누르시면 됩니다." style="margin-top: 32px"/>
              <ArcordianView number="7" title="통합발급을 받아야 하는데 개별발급으로 잘못 받았어요." text="카카오톡 @돌봄으로 [성함 / 연락처 / 수요기업명]과 함께 해당 내용 적어주시면 초기화처리 도와드리도록 하겠습니다." style="margin-top: 32px"/>
              <ArcordianView number="8" title="결제 후 환불 가능한가요?" text="서비스 이용이 원활하지 않은 경우에는 환불처리 해드리고 있으나 비대면 바우처 결제기한이 지난 뒤에는 환불하셔도 다른 서비스 결제가 불가능하오니 참고 부탁드립니다." style="margin-top: 32px"/>
              <ArcordianView number="9" title="쿠폰 발송은 언제 되나요?" text="결제일로부터 영업일 기준 3일 이후에 입력하신 메일로 발송되고 있습니다." style="margin-top: 32px"/>
            </div>
          </div>

            <div style="margin-top: 240px;">
                <span class="emphasized">[</span>
                <span> 돌봄플러스, 지금 시작하기 </span>
                <span class="emphasized">]</span>
            </div>

            <div class="contact-detail-container">
                <div class="contact-detail-item">
                    <span>담당자 직위</span>
                    <input class="input-box" type="text" style="margin-top: 137px; margin-left: 60px;" v-model="position"/>
                </div>
                <div class="contact-detail-item">
                    <span>담당자 이름</span>
                    <input class="input-box" type="text" style="margin-top: 42px; margin-left: 60px;" v-model="name"/>
                </div>
                <div class="contact-detail-item">
                    <span>담당자 이메일</span>
                    <input class="input-box" type="email" style="margin-top: 42px; margin-left: 46px;" v-model="email"/>
                </div>
                <div class="contact-detail-item">
                    <span>담당자 전화번호</span>
                    <input class="input-box" type="tel" style="margin-top: 42px; margin-left: 30px;" v-model="telephone"/>
                </div>
                <div class="contact-detail-item">
                    <span>회사(기관)명</span>
                    <input class="input-box" type="text" style="margin-top: 42px; margin-left: 54px;" v-model="companyName"/>
                </div>

                <div style="display: flex; flex-direction: row; margin-top: 140px; ">
                    <div style="margin-top: 20px;">
                        <span>문의내용</span>
                    </div>
                    <textarea class="input-box-multiline" type="text" v-model="content"/>
                </div>
            </div>
        </div>

        <div style="text-align: center; margin-top: 140px; padding-bottom: 184px;">
            <img src="@/assets/pc/btn-part-10-sendbtn.png" @click="checkValidate" style="cursor: pointer"/>
        </div>

        <md-dialog-alert
                :md-active.sync="show"
                md-title="알림"
                :md-content="dialogContent" />
    </div>
</template>

<script>

    import ArcordianView from "@/components/AccordionView";

    const Api = require('@/api');

    export default {
        name: "pc",
        components: {
          ArcordianView
        },
        data() {
            return {
                email: '',
                telephone: '',
                companyName: '',
                name: '',
                position: '',
                content: '',
                show: false,
                dialogContent: ''
            }
        },
        methods: {
            showDialog(msg) {
                this.dialogContent = msg;
                this.show = true;
            },
            checkValidate() {
                if (this.position.length == 0) {
                    this.showDialog("담당자 직위를 입력해 주세요.")
                    return
                }

                if (this.name.length == 0) {
                    this.showDialog("담당자 이름을 입력해 주세요.")
                    return
                }

                if (this.email.length == 0) {
                    this.showDialog("담당자 이메일을 입력해 주세요.")
                    return
                }

                if (this.telephone.length == 0) {
                    this.showDialog("담당자 전화번호를 입력해 주세요.")
                    return
                }

                if (this.companyName.length == 0) {
                    this.showDialog("회사(기관)명을 입력해 주세요.")
                    return
                }

                if (this.content.length == 0) {
                    this.showDialog("문의내용을 입력해 주세요.")
                    return
                }

                this.handleSendEmail()
            },
            async handleSendEmail() {
                let result = await Api.sendEmail(this.name, this.position, this.companyName, this.email, this.telephone, this.content)

                if (result.data.res == 0) {
                    this.showDialog("문의 메일이 전송되었습니다.")
                    this.name = ""
                    this.position = ""
                    this.companyName = ""
                    this.email = ""
                    this.telephone = ""
                    this.content = ""
                } else {
                    this.showDialog("일시적인 오류로 메일 전송에 실패하였습니다. 잠시 후 다시 시도해 주세요.")
                }
            }
        }
    }
</script>

<style scoped>

    .pc-root-container {
        font-family: 'Noto Sans KR', sans-serif;
        background-color: white;
    }

    .header {
        position: relative;
    }

    .logo-container {
        position: absolute;
        top: 44px;
        left: 133px;
    }

    .header-title {
        display: block;
        text-align: left;
        margin-top: 355px;
        font-size: 45px;
        font-weight: 500;
        color: #000000;
        line-height: 1.44;
        letter-spacing: -1.18px;
    }

    .header_character-container {
        position: absolute;
        bottom: 38px;
        width: 100%;
    }

    .introduce_container {
        display: flex;
        flex-direction: row;
        justify-content: center;
        margin-top: 51px;
    }

    .introduce_container > span {
        display: block;
        margin-left: 50px;
        font-family: 'Noto Sans KR', sans-serif;
        align-self: center;
        text-align: left;
        font-size: 20px;
        font-weight: 400;
        line-height: 1.55;
        letter-spacing: normal;
        color: #454545;
    }

    .score-container {
        margin-top: -1px;
        background-color: #8d00af;
        padding-top: 22px;
        padding-bottom: 24px;
    }

    .score-title {
        font-family: 'Noto Sans KR', sans-serif;
        font-size: 24px;
        font-weight: 400;
        line-height: 1.29;
        color: #ffffff
    }

    .score-title .poppins {
        font-family: 'Poppins', sans-serif;
        font-size: 40px;
    }

    .chick-title {
        font-weight: 400;
        font-size: 20px;
        line-height: 1.5;
        color: #454545;
    }

    .dorbom-score-container {
        background-color: rgba(252, 210, 31, 0.1);
        padding-top: 36px;
        padding-bottom: 29px;
    }

    .dorbom-score-container > div:nth-child(2) {
        margin-top: 50px;
        margin-bottom: 26px;
    }

    .dorbom-score-container > span:nth-child(1) {
        display: block;
        font-size: 30px;
        font-weight: 500;
        line-height: 1.03;
        color: #000000;

    }

    .dorbom-score-container > div {
        font-family: 'Poppins', sans-serif;
        margin-top: 20px;
        color: #8d00af;
    }

    .dorbom-score-container > div > span:nth-child(1) {
        font-size: 70px;
        font-weight: 800;
    }

    .dorbom-score-container > div > span:nth-child(2) {
        font-size: 36px;
    }

    .dorbom-score-container > span:nth-child(3) {
        display: block;
        font-size: 17px;
        line-height: 1.82;
        color: rgba(0, 0, 0, 0.25);
    }

    .why-special {
        padding-top: 250px;
        font-weight: 500;
        font-size: 32px;
        color: #454545;
        letter-spacing: -0.53px;
    }

    .why-special .emphasized {
        color: #9c00b5;
    }

    .insurance-container {
        padding-top: 46px;
        background-color: #f4f4f4;
        font-size: 30px;
        font-weight: 500;
        line-height: 1.03;
        color: #000000;
    }

    .service-container {
        padding-top: 80px;
        padding-bottom: 103px;
        font-size: 32px;
        font-weight: 500;
        line-height: 1;
        letter-spacing: -0.53px;
        background-color: #f4f4f4;
        color: #454545;
    }

    .service-container .emphasized {
        color: #9c00b5;
    }

    .allhappy-container {
        padding-top: 237px;
        padding-bottom: 280px;
        font-size: 32px;
        font-weight: 500;
        line-height: 1;
        letter-spacing: -0.53px;
        color: #454545;
        background-color: white;
    }

    .allhappy-container .emphasized {
        color: #9c00b5;
    }

    .allhappy-container > div:nth-child(2) {
        font-size: 18px;
        line-height: 1.5;
        color: #454545;
        margin-top: 30px;
        font-weight: 400;
    }

    .allhappy-container > div:nth-child(3) {
        font-size: 24px;
        line-height: 1.13;
        color: #454545;
        margin-top: 26px;
        font-weight: 400;
    }

    .allhappy1-container {
        padding-top: 147px;
        padding-bottom: 120px;
        font-size: 32px;
        font-weight: 500;
        line-height: 1;
        letter-spacing: -0.53px;
        color: #454545;
    }

    .allhappy1-container .emphasized {
        color: #9c00b5;
    }

    .allhappy-caution {
        font-size: 14px;
        margin-top: 26px;
        color: rgba(0, 0, 0, 0.25);
        font-weight: 400;
        text-align: center;
        margin-left: -300px;
        text-align: center;
    }

    .allhappy2-container {
        padding-top: 57px;
        padding-bottom: 78px;
        font-size: 32px;
        font-weight: 500;
        line-height: 1;
        letter-spacing: -0.53px;
        color: #454545;
        background-color: #f4f4f4;
    }

    .allhappy2-container .emphasized {
        color: #9c00b5;
    }

    .contact-container {
        padding-top: 120px;
        padding-left: 200px;
        font-size: 40px;
        font-weight: 500;
        line-height: 1;
        letter-spacing: -0.53px;
        color: #454545;
        text-align: left;
    }

    .contact-container .emphasized {
        color: #9c00b5;
    }

    .contact-detail-container {
        display: flex;
        flex-direction: column;
        color: #454545;
        font-size: 18px;
        font-weight: 500;
    }

    .contact-detail-item {
        text-align: left;
    }

    .input-box {
        object-fit: contain;
        border-radius: 5px;
        border: solid 2px rgba(0, 0, 0, 0.25);
        min-height: 45px;
        min-width: 500px;
        padding-left: 16px;
        font-size: 18px;
    }

    .input-box-multiline {
        font-family: 'Noto Sans KR', sans-serif;
        margin-left: 83px;
        width: 816px;
        height: 402px;
        resize:none;
        padding: 16px;
        font-size: 18px;
        border-radius: 5px;
        border: solid 2px rgba(0, 0, 0, 0.25);
    }
</style>